import type { CookieInterface } from '@app/services/CookieManager'

import { tryJSONparse } from '@app/utils/tryJSONparse'

import { unwrapOr } from '@app/packages/Result/Result'

import { COOKIE_NAME } from './shared'

export async function read(cookies: CookieInterface): Promise<Record<string, string | object> | null> {
  const data = await cookies.get(COOKIE_NAME)
  if (data) {
    return unwrapOr(tryJSONparse<any>(decodeURIComponent(data)), null)
  }
  return null
}
